import axios from 'axios';

import { IAdvertisementSubcategory } from '@/shared/model/advertisement-subcategory.model';

const baseApiUrl = 'api/advertisement-subcategories';

export default class AdvertisementSubcategoryService {
  public find(id: number): Promise<IAdvertisementSubcategory> {
    return new Promise<IAdvertisementSubcategory>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAdvertisementSubcategory): Promise<IAdvertisementSubcategory> {
    return new Promise<IAdvertisementSubcategory>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAdvertisementSubcategory): Promise<IAdvertisementSubcategory> {
    return new Promise<IAdvertisementSubcategory>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
